<template>
  <div class="app-container">
    <div class="games-container">
      <div class="game-list-container">
        <el-alert
    :title="title"
    :description="msg"
    :closable="false"
    type="success"
    show-icon>
  </el-alert>
      <div class="back-btn" ><el-button type="primary" @click="back()">返回首頁</el-button></div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {  
      title:this.$route.query.title,
      msg:this.$route.query.msg,
    };
  },
  methods: {
    back(){
        this.$router.push('/');
    }
  }  
};
</script>


 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:link {color:#409EFF; text-decoration:none;} 
a:active{color:#409EFF; text-decoration:none;}
a:visited {color:#409EFF; text-decoration:none;}
a:hover {color:#409EFF; text-decoration:none;}
.app-container {
  display: block;
}
.games-container {
  max-width: 1281px;
  margin: auto;
}
.game-list-container {
  padding-bottom: 50px;
}
.back-btn {
   max-width: 1281px;  
   text-align: center;
}
.el-button--primary {
    min-width:228px;
    margin-top: 50px;
    min-height: 38px;
}

</style>


// WEBPACK FOOTER //
// src/components/Success.vue